import LegalPage, { LegalSection } from "@/components/LegalPage";

export default function Datenschutz() {
  return (
    <LegalPage title="Datenschutzerklärung" testid="datenschutz-page">
      <LegalSection title="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p>
          <strong className="text-[#1A382B]">Kleingartenanlage „Schönwald“ e.V.</strong>
          <br />
          Liliensteinweg 6, 13158 Berlin
          <br />
          E-Mail:{" "}
          <a href="mailto:info@kga-schoenwald.de" className="font-medium text-[#1A382B] underline decoration-[#C85A32]/50 underline-offset-4 hover:text-[#C85A32]" data-testid="datenschutz-mail">
            info@kga-schoenwald.de
          </a>
        </p>
      </LegalSection>

      <LegalSection title="2. Allgemeines zur Datenverarbeitung">
        <p>
          Wir verarbeiten personenbezogene Daten nur, soweit dies für die Bereitstellung dieser
          Website, die Bearbeitung Ihrer Anfragen und die Vereins- und Wasserabrechnung erforderlich
          ist. Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. b DSGVO (Vertrag bzw.
          vorvertragliche Maßnahmen) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
          funktionierenden Website und Vereinskommunikation).
        </p>
      </LegalSection>

      <LegalSection title="3. Zugriffsdaten und Hosting">
        <p>
          Beim Aufruf der Website werden durch den Hosting-Dienstleister automatisch technische
          Zugriffsdaten (z. B. IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp) in
          Server-Logdateien verarbeitet. Dies dient dem sicheren und stabilen Betrieb der Website
          (Art. 6 Abs. 1 lit. f DSGVO). Eine Zusammenführung mit anderen Datenquellen findet nicht
          statt.
        </p>
      </LegalSection>

      <LegalSection title="4. Kontaktformular">
        <p>
          Wenn Sie uns über das Kontaktformular schreiben, verarbeiten wir Ihren Namen, Ihre
          E-Mail-Adresse, den gewählten Betreff und Ihre Nachricht zur Bearbeitung der Anfrage
          (Art. 6 Abs. 1 lit. b und f DSGVO). Die Daten werden in einer geschützten Datenbank
          gespeichert und nicht an Dritte weitergegeben. Nach abschließender Bearbeitung Ihrer
          Anfrage werden die Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
          bestehen.
        </p>
      </LegalSection>

      <LegalSection title="5. Zählerstand-Übermittlung">
        <p>
          Bei der Übermittlung Ihres Wasserzählerstands verarbeiten wir folgende Daten:
          Wassernutzernummer, Vor- und Nachname, Parzellennummer, Weg und Hausnummer innerhalb der
          Anlage, Telefonnummer, E-Mail-Adresse, Ablesedatum, Zählerstand und Zählernummer sowie
          ggf. Ihre Bemerkung. Die Verarbeitung erfolgt zur Durchführung der Wasser- und
          Abwasserabrechnung im Rahmen des Wassernutzungsverhältnisses (Art. 6 Abs. 1 lit. b DSGVO).
          Die Daten werden nur so lange gespeichert, wie es für die Abrechnung und gesetzliche
          Aufbewahrungspflichten erforderlich ist.
        </p>
      </LegalSection>

      <LegalSection title="6. Vorstandsbereich">
        <p>
          Der geschützte Vorstandsbereich verwendet nach der Anmeldung ein technisch notwendiges
          Anmelde-Token, das im Speicher Ihres Browsers abgelegt wird und der Sitzungsverwaltung
          dient. Es werden keine Tracking-Cookies durch den Verein gesetzt.
        </p>
      </LegalSection>

      <LegalSection title="7. Forum und E-Mail-Benachrichtigungen">
        <p>
          Bei der Registrierung für das geschlossene Gärtner-Forum verarbeiten wir Ihren Vor- und
          Nachnamen (Klarnamen), Ihre E-Mail-Adresse, Ihre Parzellennummer (freiwillig) sowie Ihre
          Beiträge und Kommentare. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Nutzung des
          Forumsangebots). Der Vorstand schaltet Registrierungen erst nach Prüfung frei und kann
          Konten und Beiträge bei Bedarf löschen.
        </p>
        <p>
          E-Mail-Benachrichtigungen über neue Antworten in Beiträgen, die Sie erstellt oder
          kommentiert haben, erhalten Sie nur, wenn Sie bei der Registrierung oder im Forum
          ausdrücklich eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO). Jede Benachrichtigung
          enthält einen Abmelde-Link; die Einwilligung können Sie jederzeit mit Wirkung für die
          Zukunft widerrufen – per Link in der E-Mail oder direkt im Forum.
        </p>
      </LegalSection>

      <LegalSection title="8. Ihre Rechte">
        <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine formlose E-Mail an info@kga-schoenwald.de.
        </p>
      </LegalSection>

      <LegalSection title="9. Beschwerderecht">
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig
          ist die Berliner Beauftragte für Datenschutz und Informationsfreiheit, Alt-Moabit 59–61,
          10555 Berlin.
        </p>
      </LegalSection>

      <p className="font-jbm text-xs tracking-wider uppercase text-[#6F7E73]">Stand: Juli 2026</p>
    </LegalPage>
  );
}
